import { filter } from 'rxjs/operators';
import { ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionResourceService } from "../service/resources/permission/permissionResource.service";
import { Observable, Subscription } from 'rxjs';
import { IQuote } from "libraries/service/resources/airTrip/IGetAirTripQuotes";

/**
 * PermissionIf directive
 * remove element from DOM depending on permissions
 */

@Directive({
    selector: '[permissionIf]'
})
export class PermissionIfDirective implements OnInit, OnDestroy {

    /** Code of the permission to check. If the string starts with a !, it acts as a NOT. */
    @Input('permissionIf')
    public path: string;

    /**
     * #35933
     * add ability to restrict permission on directive
     */
    @Input()
    public permissionIfAirQuote: IQuote;


    private readonly subscription: Subscription = new Subscription();
    private destroyed: boolean = false;

    constructor(
        private readonly templateRef: TemplateRef<any>,
        private readonly viewContainer: ViewContainerRef,
        private readonly permission: PermissionResourceService,
        private readonly changeDetector: ChangeDetectorRef,
    ) {
    }

    public ngOnInit(): void {
        // Handles permission code starting with a !
        let targetPermissionStatus: boolean = true;
        let aPath: string = this.path;
        if (this.path.startsWith('!')) {
            targetPermissionStatus = false;
            aPath = this.path.substring(1);
        }

        const obs: Observable<boolean> = Boolean(this.permissionIfAirQuote)
            ? this.permission.hasPermissionWithRestriction(aPath, null, this.permissionIfAirQuote)
            : this.permission.hasPermission(aPath);

        // Even if removing the subscription does not seem necessary,
        // I have some errors about code ran after a component was destroyed
        this.subscription.add(
            obs.pipe(
                // Same thing about this property: if I don't filter this
                // I get some errors about some code ran after the component
                // has been destroyed
                filter((): boolean => !this.destroyed)
            ).subscribe((hasPermission: boolean): void => {
                if (targetPermissionStatus === hasPermission) {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                } else {
                    this.viewContainer.clear();
                }
                this.changeDetector.detectChanges();
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.destroyed = true;
    }
}
